import { FC } from "react";
import { InfoCardSection } from "ui-library";
import { infoCardGroup, infoCard } from "types/CMS/Unum/InfoCardGroup";
import { PortableText } from "@kontent-ai/rich-text-resolver/utils/react";
import useInternalExternalNavigate from "hooks/CMS/useInternalExternalNavigate/useInternalExternalNavigate";

const EmployerInfoCardsSection: FC<{ section: infoCardGroup }> = ({
  section,
}) => {
  const internalExternalNavigate = useInternalExternalNavigate();
  return (
    <InfoCardSection
      infoCards={section?.cards.map((item: infoCard) => ({
        title: item.title,
        body: item.body,
        onClick: () => {
          internalExternalNavigate(item.link);
        },
        actionText: item.link.label,
      }))}
      subTitle={<PortableText {...section.intro} />}
      title={section?.title}
      showHeader={section?.showHeader}
    />
  );
};

export default EmployerInfoCardsSection;
